import * as React from 'react';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';
import {ImageAsBackground} from '../ImageAsBackground/ImageAsBackground';

import * as Styles from './AppLogo.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
    src: string;
    className?: string;
}

export const AppLogo: React.FC<Props> = (props) => {
    const {src, className, ...rest} = props;

    const classes = new ClassNameBuilder(Styles, 'container')
        .add(className)
        .toString();

    return (
        <ImageAsBackground src={src} className={classes} {...rest} />
    );
};
